export default __webpack_public_path__ + "static/media/brasilpassagens.800168bc.ico";